<template>
    <va-form :id="id" :item="item">
        <v-row justify="center">
            <v-col sm="6">
                <base-material-card>
                    <template v-slot:heading>
                        <div class="display-2">
                            {{ title }}
                        </div>
                    </template>
                    <v-card-text>
                        <va-text-input source="name" required></va-text-input>
                        <va-autocomplete-input
                            source="type"
                            reference="product_types"
                            required
                            model="type_id"
                        ></va-autocomplete-input>
                        <va-autocomplete-input
                            source="supplier"
                            reference="suppliers"
                            required
                            model="supplier_id"
                        ></va-autocomplete-input>
                    </v-card-text>
                    <va-save-button></va-save-button>
                </base-material-card>
            </v-col>
        </v-row>
    </va-form>
</template>

<script>
export default {
    props: ["id", "title", "item"]
};
</script>
